<template>
  <PreviewSheet class="video-preview">
    <div class="flex-col gap-14">
      <div class="align-center flex-col gap-8">
        <div class="video-preview__text align-center flex-col gap-4">
          <PreviewTypography
            :text="currentBlockParams.header || ''"
            variant="heading2"
          />
          <PreviewTypography
            :text="currentBlockParams.body || ''"
            variant="paragraphRegular"
          />
        </div>
      </div>
      <div class="video-preview__video-wrapper">
        <VideoPreviewPlayer
          class="video-preview__video"
          class-name="video-preview__video"
          :title="currentBlockParams.header || 'Video'"
          :video="currentBlockParams.video"
        />
      </div>
    </div>
  </PreviewSheet>
</template>
<script lang="ts" setup>
import { computed } from 'vue'

import VideoPreviewPlayer from '@/features/website-builder/builder/components/VideoPreviewPlayer.vue'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import PreviewTypography from '@/lib/builder/public/preview/PreviewTypography.vue'

import type { VideoSection } from '../../../WebsiteBuilder.types'

const props = defineProps<{
  content: VideoSection
}>()

const currentBlockParams = computed(() => props.content?.params)
</script>
<style lang="scss" scoped>
.video-preview {
  padding: 120px;

  &__text {
    max-width: 672px;
    padding: 0 16px;
    text-align: center;
  }

  &__video-wrapper {
    overflow: hidden;
    position: relative;
    aspect-ratio: 16 / 9;
    border-radius: 32px;
  }

  &__video {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    border: 0;
  }
}
</style>
